// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"c2d980ab","127":"a0754a54","243":"e546d049","355":"cc4cb26e","358":"2c8e223e","471":"112cccf0","479":"2c0b0321","510":"fc4b87f2","694":"21afedac","739":"42e538c6","804":"dc6cac42","816":"eaaf89a4"}[chunkId] + ".chunk.js";
};